import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, 
    Grid,
    Button, TextField} from "@mui/material"
import React, { useEffect, useState, useRef } from "react";
import {points_1_str, points_2_str, points_3_str, points_heart_str,
    pedals_str, center_str, leaves_str}  from "./card.js"
import Canvas from "./canvas" 

function str_to_points(str) {
    return str.trim().split("\n").map( line => {
        const [x_str, y_str] = line.split(",")
        return [parseFloat(x_str), parseFloat(y_str)]
    } )
}


const generateNormalPoints = (count, centerX = 50, centerY = 50, stdDev = 20) => {
    const points = []
    for (let i = 0; i < count; i++) {
        // Box-Muller transform for normal distribution
        
        const x = i % 200
        const y = (10 + 10*i)/600
        
        points.push([x, y])
    }
    return points
}

const points_1 = str_to_points(points_1_str)//.map(xy => [xy[0], xy[1], "red"])
const points_2 = str_to_points(points_2_str)//.map(xy => [xy[0], xy[1], "blue"])
const points_3 = str_to_points(points_3_str)//.map(xy => [xy[0], xy[1], "green"])
const points_heart = str_to_points(points_heart_str)//.map(xy => [xy[0], xy[1], "red"])
const points_pedal = str_to_points(pedals_str)
const points_center = str_to_points(center_str)
const points_leafs = str_to_points(leaves_str)
const points = ["color_red", ...points_1, 
    "color_green", ...points_2, 
    "color_blue", ...points_3,
    "color_red",  ...points_heart,
    "pause", "clear",
    "color_red", ...points_pedal,
    "color_yellow", ...points_center,
    "color_green", ...points_leafs]
// const points = generateNormalPoints(10000).map(xy => [xy[0], xy[1], "red"])


const ScribbleCardDialog = (props) => {
    const [id, setId] = useState(1);
    const [running, setRunning] = useState(false);

    useEffect(() => {
        if (!running) return;
        const pts = points[id]
        // console.log(id, ":", pts)            
        if(  pts == "pause") {
            console.log("PAUSE ")
            setRunning(prev => 1-prev)
            setId(prev => prev + 1)
        } else {
            const intervalId = setInterval(() => {
                setId(prev => prev + 1);
                if(id > points.length) { setRunning(0)}
            }, 1);
            return () => clearInterval(intervalId);
        }
    }, [id, running]);

    const handleClick = () => {
        if(id < points.length) {
            setRunning(1-running)
        }
        else {
            setId(0); setRunning(1)
        }
    }

    const canvasRef = useRef(null)



    return (
        <Dialog open={props.open} onClose={props.onClose} fullWidth>
            <DialogTitle>
                Открытка
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Нажми чтобы запустить
                </DialogContentText>
                    <div onDoubleClick={() => {console.log("Clicked"); setId(0);}}
                        onClick = {handleClick}>
                        <Canvas id={id} points={points} />
                    </div>                
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handelOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ScribbleCardDialog;
